import React from 'react';
import NextLink from 'next/link';
import { SkipperLogo } from '@components/base/elements/SkipperLogo';

export function SkipperTextLogo({ href = '/auth/signin' }: { href?: string }) {
    return (
        <NextLink href={href}>
            <div className="flex items-center cursor-pointer">
                <SkipperLogo className="w-12 h-12 fill-current text-teal-600 mr-2 transform scale-110" />
                <h1 className="text-4xl text-passport font-bold font-inter">Skipper</h1>
            </div>
        </NextLink>
    );
}
